import React from "react";
import { NavLink } from "react-router-dom";
import './style.css';

const Card = ({ id, to, title, date }) => {
  return (
    <>
      <NavLink
        id={id}
        to={to}
        className="cardContainer"
        target="_blank"
      >
        <h2 className="newsLetterTitle">{title}</h2>
        <div className="newsLetterDate">{date}</div>
        <span>버튼</span>
      </NavLink>
    </>
  )
}
export default Card;